var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visability('image'))?_c('div',{staticClass:"images-group-4 d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"position-relative",style:({..._vm.dropShadow})},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }